/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Homytrust {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List available verification options that are configured in the current environment.
   *
   * @tags Homytrust
   * @name GetVerificationOptions
   * @summary Get Verification Options
   * @request GET:/api/homytrust/options
   * @secure
   */
  getVerificationOptions = (params = {}) =>
    this.http.request({
      path: `/api/homytrust/options`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve or provision authenticated user's trust profile with configured options.
   *
   * @tags Homytrust
   * @name GetMyTrustProfile
   * @summary Get My Trust Profile
   * @request GET:/api/homytrust/profile/me
   * @secure
   */
  getMyTrustProfile = (params = {}) =>
    this.http.request({
      path: `/api/homytrust/profile/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve public/shared trust profile for a specified user.
   *
   * @tags Homytrust
   * @name GetPublicTrustProfile
   * @summary Get Public Trust Profile
   * @request GET:/api/homytrust/profiles/users/{user_id}
   * @secure
   */
  getPublicTrustProfile = (userId, params = {}) =>
    this.http.request({
      path: `/api/homytrust/profiles/users/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve public/shared trust profile for a specified user.
   *
   * @tags Homytrust
   * @name GetPublicTrustProfile2
   * @summary Get Public Trust Profile
   * @request GET:/api/homytrust/profile/{user_id}
   * @originalName getPublicTrustProfile
   * @duplicate
   * @secure
   */
  getPublicTrustProfile2 = (userId, params = {}) =>
    this.http.request({
      path: `/api/homytrust/profile/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Initiate verification workflow. Rejects direct invocation with HTTP 400 Bad Request if the backing provider is not configured.
   *
   * @tags Homytrust
   * @name InitiateVerification
   * @summary Initiate Verification
   * @request POST:/api/homytrust/verifications/{verification_type}/initiate
   * @secure
   */
  initiateVerification = (verificationType, data, params = {}) =>
    this.http.request({
      path: `/api/homytrust/verifications/${verificationType}/initiate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Confirm or submit proof for a verification type. Rejects direct invocation with HTTP 400 Bad Request if the backing provider is not configured.
   *
   * @tags Homytrust
   * @name ConfirmVerification
   * @summary Confirm Verification
   * @request POST:/api/homytrust/verifications/{verification_type}/confirm
   * @secure
   */
  confirmVerification = (verificationType, data, params = {}) =>
    this.http.request({
      path: `/api/homytrust/verifications/${verificationType}/confirm`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
